import { render, staticRenderFns } from "./cqRightEchats1.vue?vue&type=template&id=38318a07&scoped=true&"
import script from "./cqRightEchats1.vue?vue&type=script&lang=js&"
export * from "./cqRightEchats1.vue?vue&type=script&lang=js&"
import style0 from "./cqRightEchats1.vue?vue&type=style&index=0&id=38318a07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38318a07",
  null
  
)

export default component.exports